import { baseFareBackend } from "../base/baseUrl";

const URL_ESTIMATE_FARE = "/api/v1/estimate-fare";

export const estimateFare = async (fare) => {
  return await baseFareBackend.post(URL_ESTIMATE_FARE, JSON.stringify(fare), {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
